import { Button, Grid } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-community";
import { downloadQCBDFile } from "../utils/downloadQCBDFile";

type Props = EditableCallbackParams;

export const QCBDDownloadButton = ({ data }: Props) => {
	const handleDownloadClick = () => {
		if (data?.URL && data?.Filename) {
			downloadQCBDFile(data.URL, data.Filename);
		}
	};

	return (
		<Grid container spacing={1} style={{ alignItems: "center" }}>
			{data?.URL && data?.Filename && (
				<Grid item md={12} xs={12}>
					<Button
						fullWidth
						variant="outlined"
						style={{
							textDecoration: "none !important",
							fontWeight: 500,
							fontSize: "12px",
							borderRadius: "3px",
							border: "1px solid #3F51B5",
							color: "#3F51B5",
							background: "#FFFF",
						}}
						onClick={handleDownloadClick}
					>
						DOWNLOAD
					</Button>
				</Grid>
			)}
		</Grid>
	);
};
